import { createStateContext } from "react-use";

import { createDeploymentModel } from "@ds/modules/deployments/utils/model";

const [useCreateDeployment, CreateDeploymentProvider] = createStateContext<Deployment>(createDeploymentModel());

export { useCreateDeployment, CreateDeploymentProvider };
